import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Layout from '../../../components/Layout';
import TeacherNavbar from '../../../components/TeacherNavbar/TeacherNavbar';
import { axiosInstance } from '../../../utils/tokenUtils';
import { toast } from 'react-hot-toast';
import ReactCountryFlag from 'react-country-flag';
import './RescheduledRequest.css';
import RescheduledRequestList from './RescheduledRequestList';
import RescheduledRequestDetail from './RescheduledRequestDetail';

// Utility function to convert country names to ISO codes
const getCountryCode = countryName => {
  const countryMap = {
    Egypt: 'EG',
    Iran: 'IR',
    Bahrain: 'BH',
    'United States': 'US',
    'United Kingdom': 'GB',
    Canada: 'CA',
    Australia: 'AU',
    Germany: 'DE',
    France: 'FR',
    India: 'IN',
    China: 'CN',
    Japan: 'JP',
    'South Korea': 'KR',
    Brazil: 'BR',
    Mexico: 'MX',
    Argentina: 'AR',
    'South Africa': 'ZA',
    Nigeria: 'NG',
    Kenya: 'KE',
    Morocco: 'MA',
    Algeria: 'DZ',
    Tunisia: 'TN',
    Libya: 'LY',
    Sudan: 'SD',
    Ethiopia: 'ET',
    Somalia: 'SO',
    Djibouti: 'DJ',
    Eritrea: 'ER',
    Yemen: 'YE',
    Oman: 'OM',
    Qatar: 'QA',
    Kuwait: 'KW',
    'Saudi Arabia': 'SA',
    Iraq: 'IQ',
    Syria: 'SY',
    Lebanon: 'LB',
    Jordan: 'JO',
    Palestine: 'PS',
    Israel: 'IL',
    Turkey: 'TR',
    Cyprus: 'CY',
    Greece: 'GR',
    Italy: 'IT',
    Spain: 'ES',
    Portugal: 'PT',
    Netherlands: 'NL',
    Belgium: 'BE',
    Switzerland: 'CH',
    Austria: 'AT',
    Poland: 'PL',
    'Czech Republic': 'CZ',
    Slovakia: 'SK',
    Hungary: 'HU',
    Romania: 'RO',
    Bulgaria: 'BG',
    Croatia: 'HR',
    Slovenia: 'SI',
    Serbia: 'RS',
    'Bosnia and Herzegovina': 'BA',
    Montenegro: 'ME',
    'North Macedonia': 'MK',
    Albania: 'AL',
    Kosovo: 'XK',
    Moldova: 'MD',
    Ukraine: 'UA',
    Belarus: 'BY',
    Lithuania: 'LT',
    Latvia: 'LV',
    Estonia: 'EE',
    Finland: 'FI',
    Sweden: 'SE',
    Norway: 'NO',
    Denmark: 'DK',
    Iceland: 'IS',
    Ireland: 'IE',
    'New Zealand': 'NZ',
    Singapore: 'SG',
    Malaysia: 'MY',
    Thailand: 'TH',
    Vietnam: 'VN',
    Philippines: 'PH',
    Indonesia: 'ID',
    Pakistan: 'PK',
    Afghanistan: 'AF',
    Bangladesh: 'BD',
    'Sri Lanka': 'LK',
    Nepal: 'NP',
    Bhutan: 'BT',
    Myanmar: 'MM',
    Cambodia: 'KH',
    Laos: 'LA',
    Mongolia: 'MN',
    Kazakhstan: 'KZ',
    Uzbekistan: 'UZ',
    Kyrgyzstan: 'KG',
    Tajikistan: 'TJ',
    Turkmenistan: 'TM',
    Azerbaijan: 'AZ',
    Georgia: 'GE',
    Armenia: 'AM',
    Russia: 'RU',
    Chile: 'CL',
    Peru: 'PE',
    Colombia: 'CO',
    Venezuela: 'VE',
    Ecuador: 'EC',
    Bolivia: 'BO',
    Paraguay: 'PY',
    Uruguay: 'UY',
    Guyana: 'GY',
    Suriname: 'SR',
    'French Guiana': 'GF',
    'Falkland Islands': 'FK',
    Greenland: 'GL',
    Iceland: 'IS',
    'Faroe Islands': 'FO',
    'Svalbard and Jan Mayen': 'SJ',
    'Bouvet Island': 'BV',
    'South Georgia and the South Sandwich Islands': 'GS',
    'Heard Island and McDonald Islands': 'HM',
    'French Southern Territories': 'TF',
    'British Indian Ocean Territory': 'IO',
    'Christmas Island': 'CX',
    'Cocos (Keeling) Islands': 'CC',
    'Norfolk Island': 'NF',
    Pitcairn: 'PN',
    Tokelau: 'TK',
    Niue: 'NU',
    'Cook Islands': 'CK',
    'Wallis and Futuna': 'WF',
    'French Polynesia': 'PF',
    'New Caledonia': 'NC',
    Vanuatu: 'VU',
    Fiji: 'FJ',
    'Solomon Islands': 'SB',
    'Papua New Guinea': 'PG',
    'Timor-Leste': 'TL',
    Brunei: 'BN',
    'East Timor': 'TL',
    Palau: 'PW',
    Micronesia: 'FM',
    'Marshall Islands': 'MH',
    Nauru: 'NR',
    Kiribati: 'KI',
    Tuvalu: 'TV',
    Samoa: 'WS',
    'American Samoa': 'AS',
    Tonga: 'TO',
    Niue: 'NU',
    'Cook Islands': 'CK',
    'French Polynesia': 'PF',
    Pitcairn: 'PN',
    'Easter Island': 'CL',
    'Galapagos Islands': 'EC',
    'Falkland Islands': 'FK',
    'South Georgia and the South Sandwich Islands': 'GS',
    'Bouvet Island': 'BV',
    'Heard Island and McDonald Islands': 'HM',
    'French Southern Territories': 'TF',
    'British Indian Ocean Territory': 'IO',
    'Christmas Island': 'CX',
    'Cocos (Keeling) Islands': 'CC',
    'Norfolk Island': 'NF',
    Pitcairn: 'PN',
    Tokelau: 'TK',
    Niue: 'NU',
    'Cook Islands': 'CK',
    'Wallis and Futuna': 'WF',
    'French Polynesia': 'PF',
    'New Caledonia': 'NC',
    Vanuatu: 'VU',
    Fiji: 'FJ',
    'Solomon Islands': 'SB',
    'Papua New Guinea': 'PG',
    'Timor-Leste': 'TL',
    Brunei: 'BN',
    'East Timor': 'TL',
    Palau: 'PW',
    Micronesia: 'FM',
    'Marshall Islands': 'MH',
    Nauru: 'NR',
    Kiribati: 'KI',
    Tuvalu: 'TV',
    Samoa: 'WS',
    'American Samoa': 'AS',
    Tonga: 'TO',
  };

  return countryMap[countryName] || 'UN'; // Return UN flag for unknown countries
};

const RescheduledRequest = () => {
  const navigate = useNavigate();
  const [currentView, setCurrentView] = useState('list');
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [actionLoading, setActionLoading] = useState(null); // Track which action is loading
  const [currentUserId, setCurrentUserId] = useState(null);

  // Fetch current user info
  const fetchCurrentUser = async () => {
    try {
      const response = await axiosInstance.get('/auth/users/me');
      if (response.data && response.data.id) {
        setCurrentUserId(response.data.id);
        console.log('Current user fetched:', response.data.id);
      }
    } catch (err) {
      console.error('Error fetching current user:', err);
    }
  };

  // Fetch reschedule requests from API
  const fetchRescheduleRequests = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axiosInstance.get('/teachers/reschedule-requests');

      // Validate API response
      if (!response.data || !Array.isArray(response.data.results)) {
        throw new Error('Invalid response format from server');
      }

      // Transform API data to match component expectations
      const transformedRequests = response.data.results
        .map(request => {
          try {
            // Validate required fields
            if (!request.id || !request.session_details) {
              console.warn('Skipping invalid request:', request);
              return null;
            }

            const student = request.session_details.students?.[0]?.user;
            const country = student?.country || 'Unknown';
            const countryCode = getCountryCode(country);

            // Validate date fields
            const newStartTime = new Date(request.new_start_time);
            const newEndTime = new Date(request.new_end_time);
            const originalStartTime = new Date(request.session_details.start_time);

            if (
              isNaN(newStartTime.getTime()) ||
              isNaN(newEndTime.getTime()) ||
              isNaN(originalStartTime.getTime())
            ) {
              console.warn('Invalid date in request:', request);
              return null;
            }

            return {
              id: request.id,
              studentName: student?.name || 'Unknown Student',
              studentAvatar: student?.profile_image || null,
              country: country,
              countryCode: countryCode,
              subject: request.session_details.subject || 'Unknown Subject',
              sessionType:
                request.session_details.session_type === 'one_on_one'
                  ? 'One-On-One Session'
                  : 'Group Session',
              rescheduleDate: newStartTime.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
              }),
              rescheduleTime: `${newStartTime.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
              })} - ${newEndTime.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
              })}`,
              originalDate: originalStartTime.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
              }),
              originalTime: `${originalStartTime.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
              })} - ${new Date(
                originalStartTime.getTime() +
                  (request.session_details.length_in_minutes || 60) * 60000
              ).toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
              })}`,
              status: request.status || 'pending',
              requestDate: new Date(request.created_at || Date.now()).toISOString().split('T')[0],
              requestedBy: request.requested_by,
              requestedTo: request.requested_to,
              // Additional API data for detail view
              apiData: request,
            };
          } catch (err) {
            console.error('Error transforming request:', request, err);
            return null;
          }
        })
        .filter(Boolean); // Remove null entries

      setRequests(transformedRequests);
    } catch (err) {
      console.error('Error fetching reschedule requests:', err);
      const errorMessage =
        err.response?.data?.message || err.message || 'Failed to fetch reschedule requests';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCurrentUser();
    fetchRescheduleRequests();
  }, []);

  const handleViewRequest = request => {
    setSelectedRequest(request);
    setCurrentView('detail');
  };

  const handleBackToList = () => {
    setCurrentView('list');
    setSelectedRequest(null);
  };

  const handleAcceptRequest = async requestId => {
    try {
      setActionLoading(requestId);

      const response = await axiosInstance.patch(
        `/teachers/reschedule-requests/${requestId}/action`,
        {
          status: 'approved',
        }
      );

      if (response.status === 200) {
        setRequests(prevRequests =>
          prevRequests.map(req => (req.id === requestId ? { ...req, status: 'approved' } : req))
        );

        // Update selected request if it's the one being accepted
        if (selectedRequest && selectedRequest.id === requestId) {
          setSelectedRequest(prev => ({ ...prev, status: 'approved' }));
        }

        toast.success('Request accepted successfully');
      }
    } catch (err) {
      console.error('Error accepting request:', err);
      let errorMessage = 'Failed to accept request';
      if (err.response?.data?.detail) {
        errorMessage = err.response.data.detail;
      } else if (err.message) {
        errorMessage = err.message;
      }
      toast.error(errorMessage);
    } finally {
      setActionLoading(null);
    }
  };

  const handleRejectRequest = async requestId => {
    try {
      setActionLoading(requestId);

      const response = await axiosInstance.patch(
        `/teachers/reschedule-requests/${requestId}/action`,
        {
          status: 'rejected',
        }
      );

      if (response.status === 200) {
        setRequests(prevRequests =>
          prevRequests.map(req => (req.id === requestId ? { ...req, status: 'rejected' } : req))
        );

        // Update selected request if it's the one being rejected
        if (selectedRequest && selectedRequest.id === requestId) {
          setSelectedRequest(prev => ({ ...prev, status: 'rejected' }));
        }

        toast.success('Request rejected successfully');
      }
    } catch (err) {
      console.error('Error rejecting request:', err);
      let errorMessage = 'Failed to reject request';
      if (err.response?.data?.detail) {
        errorMessage = err.response.data.detail;
      } else if (err.message) {
        errorMessage = err.message;
      }
      toast.error(errorMessage);
    } finally {
      setActionLoading(null);
    }
  };

  if (loading) {
    return (
      <Layout title="Klass Online | Rescheduled Request">
        <Box className="relative h-screen w-full overflow-hidden">
          <Box className="sticky top-0 left-0 right-0 z-[1000] bg-white pr-[10px]">
            <TeacherNavbar />
            <Box className="h-[calc(100vh-64px)] overflow-auto relative bg-[#F9F9F9] rounded-lg mr-[10px]">
              <Box className="reschedule-request-container">
                <Box className="flex items-center justify-center h-64">
                  <div className="flex flex-col items-center space-y-4">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                    <div className="text-lg text-gray-600">Loading reschedule requests...</div>
                  </div>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout title="Klass Online | Rescheduled Request">
        <Box className="relative h-screen w-full overflow-hidden">
          <Box className="sticky top-0 left-0 right-0 z-[1000] bg-white pr-[10px]">
            <TeacherNavbar />
            <Box className="h-[calc(100vh-64px)] overflow-auto relative bg-[#F9F9F9] rounded-lg mr-[10px]">
              <Box className="reschedule-request-container">
                <Box className="flex items-center justify-center h-64">
                  <div className="flex flex-col items-center space-y-4 text-center">
                    <div className="text-red-500">
                      <svg
                        width="48"
                        height="48"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                      >
                        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                        <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" strokeWidth="2" />
                        <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" strokeWidth="2" />
                      </svg>
                    </div>
                    <div className="text-lg text-red-600 font-semibold">
                      Failed to load reschedule requests
                    </div>
                    <div className="text-sm text-gray-600 max-w-md">{error}</div>
                    <button
                      onClick={fetchRescheduleRequests}
                      className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                    >
                      Try Again
                    </button>
                  </div>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Layout>
    );
  }

  return (
    <Layout title="Klass Online | Rescheduled Request">
      <Box className="relative h-screen w-full overflow-hidden">
        <Box className="sticky top-0 left-0 right-0 z-[1000] bg-white pr-[10px]">
          <TeacherNavbar />
          <Box className="h-[calc(100vh-64px)] overflow-auto relative bg-[#F9F9F9] rounded-lg mr-[10px]">
            <Box className="reschedule-request-container">
              {/* Breadcrumb */}
              <Box className="breadcrumb-container">
                <Typography
                  variant="body2"
                  className="breadcrumb-item"
                  onClick={() => navigate('/instructor/account')}
                >
                  My Account
                </Typography>
                <Typography variant="body2" className="breadcrumb-separator">
                  &gt;
                </Typography>
                <Typography
                  variant="body2"
                  className="breadcrumb-item"
                  onClick={() => navigate('/instructor/account')}
                >
                  Reschedule Requests
                </Typography>
                {currentView === 'detail' && (
                  <>
                    <Typography variant="body2" className="breadcrumb-separator">
                      &gt;
                    </Typography>
                    <Typography variant="body2" className="breadcrumb-item-active">
                      Details
                    </Typography>
                  </>
                )}
              </Box>

              {currentView === 'list' ? (
                <RescheduledRequestList
                  requests={requests}
                  onViewRequest={handleViewRequest}
                  onRefresh={fetchRescheduleRequests}
                  currentUserId={currentUserId}
                />
              ) : (
                <RescheduledRequestDetail
                  request={selectedRequest}
                  onBack={handleBackToList}
                  onAccept={handleAcceptRequest}
                  onReject={handleRejectRequest}
                  actionLoading={actionLoading}
                  currentUserId={currentUserId}
                />
              )}
              {console.log('Passing currentUserId to detail:', currentUserId)}
            </Box>
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};

export default RescheduledRequest;
